<template>
  <el-aside style="overflow-y: hidden;width: auto;">
    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      style="height: 100%;"
      text-color="#fff"
      background-color="rgb(48, 65, 86)"
      active-text-color="rgb(64, 158, 255)"
      :unique-opened="true"
      :router="true"
      :collapse="isCollapse"
    >
      <transition>
        <router-link to="/" style="text-decoration: none;">
          <h1
            style="width: 100%;text-align: center;margin: 0px;height: 60px;line-height: 60px;background-color: #545c64;color: white;">
            翹豐食品有限公司</h1>
        </router-link>
      </transition>
      <template v-for="item in sideItem ">
        <el-menu-item :index="resolvePath(item.path,item.children[0].path)" v-if="item.children.length ===1" :key="item.path">
          <i :class="item.meta.icon"></i>
          <span>{{item.children[0].meta.title}}</span>
        </el-menu-item>
        <el-submenu :index="item.path" v-if="item.children.length > 1" :key="item.path">
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{item.meta.title}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item :index="resolvePath(item.path,childItem.path)" v-for="childItem in item.children" :key="childItem.path">
              {{childItem.meta.title}}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
import path from 'path'

export default {
  name: 'Aside',
  data () {
    return {}
  },
  watch: {},
  computed: {
    isCollapse () {
      return this.$store.state.side
    },
    sideItem () {
      let sideItem = this.$router.options.routes
      for (let i = 0; i < sideItem.length; i++) {
        if (sideItem[i].hidden === true) {
          sideItem.splice(i, 1)
        }
      }
      return sideItem
    }
  },
  methods: {
    resolvePath (basePath, routePath) {
      return path.resolve(basePath, routePath)
    }
  }
}
</script>

<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Aside.vue